import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (params) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'PUT_STD_CRAFT_STATE',
    method: 'PUT',
  });

  useEffect(() => {
    if (params)
      exec({ url: `/api/produce-crafts/${params.id}/state`, data: { state: params.state } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return isRequestSuccessed;
});
